import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';
import { ELEVATED } from 'shared/styles/shadows';

export default makeStyles({
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 2rem)',
    maxWidth: '28.75rem',
    backgroundColor: neutral.white,
    borderRadius: '0.75rem',
    boxShadow: ELEVATED.regular,
    outline: 'none',
    color: neutral[100],
  },
  header: {
    padding: '1.5rem 1.5rem 0.5rem 1.5rem',
  },
  title: {
    margin: 0,
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
    color: neutral[100],
  },
  body: {
    padding: '0.5rem 1.5rem 1rem 1.5rem',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    fontWeight: 400,
    color: neutral[80],
  },
  footer: {
    padding: '0.75rem 1.5rem 1.5rem 1.5rem',
    display: 'flex',
    gap: '0.75rem',
  },
  btnBack: {
    flex: 1,
    appearance: 'none',
    font: 'inherit',
    cursor: 'pointer',
    padding: '0.75rem 1rem',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[80],
    borderRadius: '0.5rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[20]}`,
    '&:hover': {
      color: neutral[100],
      borderColor: neutral[30],
      backgroundColor: neutral[10],
    },
  },
  btnSubmit: {
    flex: 1,
    appearance: 'none',
    font: 'inherit',
    cursor: 'pointer',
    padding: '0.75rem 1rem',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    borderRadius: '0.5rem',
    color: neutral.white,
    backgroundColor: neutral[90],
    border: `1px solid ${neutral[90]}`,
    '&:hover:not(:disabled)': {
      backgroundColor: neutral[100],
      borderColor: neutral[100],
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
});
